import {
  Button,
  Icon,
  Input,
  Popup,
  WithPopup,
  AppTopNavi,
  Menu,
  MenuItem
} from "@abb/abb-common-ux-react";
import React from "react";
import { Translation } from "react-i18next";
import { ABB_CHECK_MARK, ABB_CLOSE } from "../../../utilities/IconConstants";
import * as CONSTANTS from "../../../utilities/Constants";
import Authorize from "../../../utilities/Authorize";
import scannerActions from "../../../flux/actions/ScannerAction";
import scannerListStore from "../../../flux/stores/scanner/ListStore";
import { IScannerViewData } from "../../../models/scanner/ScannerViewData";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../../models/shared/SidebarDetail";

interface ISidebarProps {
  authKey?: string;
  isShowPopup?: boolean;
  onCollapseSidebar: () => void;
  onActivate?: () => void;
  cloneClick?: () => void;
  onCreateClick: (e: any) => void;
  onScannerClick?: (e: any) => void;

  viewAll: (e: any) => void;

  /*======================*/
  setName?: (val: string) => void;
  inputName?: any;
  onSave?: (e: any, val: boolean) => void;
  onDeactivate?: () => void;
  module?: string;
  setCode?: (val: string) => void;
  inputCode?: any;
  isShowCodeInput?: boolean;
  nameError?: boolean;
  codeError?: boolean;
  isButtonDisabled?: boolean;
  showCloneIcon: boolean;
}
interface IState {
  isSampleWithScanner: boolean;
  listData: any;
}
export default class SidebarCollapse extends React.Component<
  ISidebarProps,
  IState
> {
  private _listData: any = [];
  constructor(props: any) {
    super(props);
    this.state = {
      isSampleWithScanner: false,
      listData: [],
    };
  }

  onScanner = () => {
    this.setState({ isSampleWithScanner: !this.state.isSampleWithScanner });
  };

  componentDidMount() {
    this.getAllScannerData();
    scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._listData = [];
      const data = state.data.result as IScannerViewData[];
      const items: ISidebarDetail[] = [];
      data.forEach((element) => {
        items.push(new SidebarDetail(element.id, element.name));
      });
      this._listData = items;
    });
  }

  getAllScannerData = () => {
    scannerActions
      .getAll(1, 0, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "%20")
      .then(() => {
        this.setState({
          listData: this._listData,
        });
      })
      .catch((e) => console.log("Error ", e));
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="sidebar-collapse">
              <div className="container">
                <ul className="row nav  justify-content-center sidebar-icons ">
                  <li className="nav-item icon-hover" onClick={this.props.onCollapseSidebar}>
                    <button
                      title={t("expand")}
                      onClick={this.props.onCollapseSidebar}
                    >
                      <Icon
                        name="abb/caret-right"
                        className="cursor-pointer"
                        sizeClass="large"
                      />
                    </button>
                  </li>
                  <Authorize scopes={[`${this.props.authKey}:Add`]}>
                  <li className="nav-item icon-hover"  onClick={this.props.onCreateClick}>
                    <button title={t("create")}>
                      {" "}
                      <Icon
                        name="abb/plus"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.props.onCreateClick}
                      />
                    </button>
                  </li></Authorize>
                  <Authorize scopes={[`${this.props.authKey}:Scan`]}>
                  <li className=" nav-item icon-hover">
                    <button title={t("Scan")}>
                      {" "}
                      <Icon
                        name="abb/qr-code"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.onScanner}
                      />
                    </button>
                  </li>
                  </Authorize>
                  {this.state.isSampleWithScanner && (
                    <div className="ul-class">
                      <Menu
                        onLostFocus={() =>
                          this.setState({ isSampleWithScanner: false })
                        }
                        style={{ top: "60px", left: "140px" }}
                      >

                        {this.state.listData.map((d: any, i: any) => {
                          return (
                            <MenuItem
                              key={i}
                              text={d.name}
                              onSelect={() => this.props.onScannerClick(d.id)}
                            />
                          );
                        })}
                      </Menu>
                    </div>
                  )}
                  <Authorize scopes={[`${this.props.authKey}:Clone`]}>
                  <li
                    className={this.props.showCloneIcon ? "nav-item icon-hover" : "d-none"}
                  >
                    <button title={t("clone")}>
                      {" "}
                      <Icon
                        name="abb/copy"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.props.onActivate}
                      />
                    </button>
                  </li></Authorize>
                  <Authorize scopes={[`${this.props.authKey}:ViewAll`]}>
                  <li className="nav-item icon-hover">
                    <button title={t("view all")}>
                      {" "}
                      <Icon
                        name="abb/list"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.props.viewAll}
                      />
                    </button>
                  </li></Authorize>
                </ul>

                <div className="text-center cursor my-1">
                  <WithPopup>
                    <div
                      className={
                        this.props.isShowPopup ? "ml-5 float-left" : null
                      }
                    ></div>
                    <Popup
                      className="popup-align-box"
                      trigger="controlled"
                      position="bottom center"
                      show={this.props.isShowPopup}
                      defaultOpen={false}
                      closeOnLostFocus={true}
                      onClose={() => this.props.onDeactivate()}
                    >
                      <p style={{ top: "-120px", left: "20px" }}>
                        <Input
                          // tslint:disable-next-line: no-unused-expression
                          inputAttributes={{ autoFocus: "true" }}
                          onKeyUp={(e) => this.props.onSave(e, true)}
                          className={
                            this.props.nameError ? "error-code mt-2" : "mt-2"
                          }
                          dataType="text"
                          label={
                            t(this.props.module) + " " + t(CONSTANTS.LABLE_NAME)
                          }
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          maxLength={250}
                          value={String(this.props.inputName)}
                          onValueChange={(val: string) =>
                            this.props.setName(val)
                          }
                          showValidationBarWhenInvalid={this.props.nameError}
                          description={
                            this.props.nameError
                              ? this.props.inputName.length
                                ? t(CONSTANTS.INSTRUMENT_NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </p>
                      {(this.props.module !== CONSTANTS.MODULE_SAMPLE_NEW &&
                        this.props.module !== CONSTANTS.MODULE_TESTPLAN) ||
                      this.props.isShowCodeInput ? (
                        <p>
                          <Input
                            onKeyUp={(e) => this.props.onSave(e, true)}
                            className={
                              this.props.codeError ? "error-code mt-2" : "mt-2"
                            }
                            dataType="text"
                            label={t(CONSTANTS.LABEL_CODEID)}
                            placeholder={t(CONSTANTS.LABEL_CODEID)}
                            maxLength={20}
                            value={String(this.props.inputCode)}
                            onValueChange={(val: string) =>
                              this.props.setCode(val)
                            }
                            showValidationBarWhenInvalid={this.props.codeError}
                            description={
                              this.props.codeError
                                ? this.props.inputCode.length
                                  ? t(
                                      CONSTANTS.INSTRUMENT_CODE_VALIDATION_ERROR
                                    )
                                  : t(CONSTANTS.FIELD_EMPTY_ERROR)
                                : ""
                            }
                          />
                        </p>
                      ) : null}

                      <div>
                        <Button
                          disabled={this.props.isButtonDisabled}
                          type="primary-blue"
                          shape="rounded"
                          text={t(CONSTANTS.BUTTON_CONFIRM)}
                          icon={ABB_CHECK_MARK}
                          className={
                            this.props.isButtonDisabled
                              ? "border"
                              : "border border-primary"
                          }
                          style={{ width: 110 }}
                          onClick={() => this.props.onSave(null, true)}
                        />
                        <Button
                          type="discreet-blue"
                          shape="rounded"
                          icon={ABB_CLOSE}
                          className="border border-primary mt-2"
                          onClick={this.props.onDeactivate}
                          style={{ marginLeft: 5 }}
                        />
                      </div>
                    </Popup>
                  </WithPopup>
                  <div className="clearfix" />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
